class StickyHeader {
  constructor() { 
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.el = document.querySelector('.js-header')
    this.lastScroll = 0
    this.headerPos = this.el.getBoundingClientRect()
  }

  bindEvents() {
    window.addEventListener('scroll', this.onScroll.bind(this))
  }

  onScroll(e) {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop

    if (currentScroll > this.headerPos.bottom && this.lastScroll <= currentScroll){
      this.lastScroll = currentScroll;
      this.el.classList.add('is-not-visible') 
    } else {
      this.lastScroll = currentScroll;
      this.el.classList.remove('is-not-visible') 
      this.el.classList.add('has-background')
    }

    if(currentScroll <= this.headerPos.bottom) {
      this.el.classList.remove('has-background') 
    }

    if(this.lastScroll == 0) {
      this.el.classList.remove('is-not-visible') 
      this.el.classList.remove('has-background') 
    }
  }
}

export default StickyHeader
